import React from 'react';
import { string, func, number, bool } from 'prop-types';
import {
    dispatchUnactionedDocketsEvent,
    handleUnactionedDocketsEvent
} from '../utils/unactioned-items-event';

export default class FilteredListingHeader extends React.Component {
    constructor(props) {
        super(props);
        // this.state = { eDocketSearch: '', eDocketError: '' };

        this.handleChange = this.handleChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.fetchUnactionedDockets = this.fetchUnactionedDockets.bind(this);
        // this.toggleCombineLoads = this.toggleCombineLoads.bind(this);
    }

    componentDidMount() {
        handleUnactionedDocketsEvent(this.fetchUnactionedDockets);
        this.updateUnactionedDocketsButton();
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.unactionedDocketCount !== this.props.unactionedDocketCount
            || prevProps.unactionedList !== this.props.unactionedList
        ) {
            this.updateUnactionedDocketsButton();
        }
    }

    updateUnactionedDocketsButton() {
        const detail = {};
        if (this.props.unactionedDocketCount > 0) {
            detail.hide = false;
            if (this.props.unactionedList) {
                detail.message = 'Return to all dockets';
            } else {
                detail.message = `${this.props.unactionedDocketCount} unactioned dockets`;
            }
        } else {
            detail.hide = true;
        }
        dispatchUnactionedDocketsEvent(detail);
    }

    fetchUnactionedDockets(detail) {
        if (detail.event !== 'apply-filters') return;

        if (this.props.unactionedList) {
            this.props.clearUnactionedDockets();
        } else {
            this.props.fetchUnactionedDockets();
        }
    }

    handleKeyPress(e, eDocketSearch) {
        // Pass the input value back to the update call back function when enter is pressed
        if (e.key === 'Enter') {
            e.preventDefault(); // stops kentico page form from submitting
            this.handleClick(eDocketSearch);
        }
    }

    handleChange(e) {
        e.preventDefault();
        // this.setState({ eDocketSearch: e.target.value });
    }

    handleClick(eDocketSearch) {
        const regex = /^[Ee]\d{7,7}-?\d{0,1}$/g;
        if (eDocketSearch.match(regex)) {
            this.props.fetchDataByNo(eDocketSearch);
        }
        // else {
        //     this.setState({ eDocketError: 'Please enter the edocket number exactly, e.g. e0012345 or e0012345-2' });
        // }
    }

    render() {
        return (
            <div className="filtered-listing-header">
                <div className="filtered-listing-header-container">
                    <div className="title">
                        {this.props.logo && (
                            <div className="logo">
                                <img src={this.props.logo} alt={this.props.companyName} />
                            </div>
                        )}
                        {this.props.companySelectionPage && (
                            <h2>
                                <a href={this.props.companySelectionPage}>
                                    <span>{this.props.subtitle}</span>
                                    <span className="link-icon">&nbsp;&#8646;</span>
                                </a>
                            </h2>
                        )}
                        {!this.props.companySelectionPage && (
                            <h2>{this.props.subtitle}</h2>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

FilteredListingHeader.propTypes = {
    subtitle: string.isRequired,
    fetchDataByNo: func.isRequired,
    unactionedDocketCount: number.isRequired,
    fetchUnactionedDockets: func.isRequired,
    clearUnactionedDockets: func.isRequired,
    unactionedList: bool.isRequired,
    companySelectionPage: string,
    logo: string,
    companyName: string
};

FilteredListingHeader.defaultProps = {
    companySelectionPage: '',
    logo: '',
    companyName: ''
    // exportCombineLoads: true,
    // exportCombineLoadToggle: null
};
